import React from 'react'

interface IProps {}

const Loader: React.FC<IProps> = () => {
  return (
    <div className="flex justify-center w-full py-75">
      <div className="loader" />
    </div>
  )
}

export default Loader
